import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { cancelReasons, paceReasons } from '../../utils/utils.common';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
@Component({
  selector: 'app-cancel-trip-modal',
  templateUrl: './cancel-trip-modal.component.html',
  styleUrls: ['./cancel-trip-modal.component.css']
})
export class CancelTripModalComponent implements OnInit, OnDestroy {
  cancelReasons = [];
  @Input() tripData;
  @Input() isNoShow;
  @Input() componentType;
  @Output() cancelTripData = new EventEmitter<any>();
  @Output() onCloseModal = new EventEmitter<string>();
  multipleCancel = {}
  cancelReason;
  cancelReasonNote;
  componentLoad = false;
  user;

  constructor(
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private corporateService: CorporateService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.getReasons();
        }
      });
  }

  getReasons() {
    const queryParams = {
      cooperate: this.tripData.cooperate ? this.tripData.cooperate : ''
    }
    if (Array.isArray(this.tripData)) {
      delete queryParams.cooperate;
    }
    this.corporateService
      .getChangeReasonByFundingSource(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.cancelReasons = data.reasons
          if (this.isNoShow) {
            this.cancelReasons = this.cancelReasons.filter(reason => {
              const myReason = reason.value.split(' - ');
              if (myReason && myReason[0] && myReason[0].toLowerCase().includes('dry run')) {

                return reason;
              }
              return null;
            })
          }
        }
      });
  }

  setReason(reason) {
    this.cancelReason = reason;
    // if (this.componentType === 'Multiple Assign') {
    //   this.multipleCancel['changeReason'] = reason;
    // } else {
    //   this.tripData['changeReason'] = reason;
    // }
  }

  cancelJob() {
    if (this.componentType === 'Multiple Assign') {
      this.multipleCancel = {
        selectedTrips: this.tripData,
        status: 'cancelled',
        changeReason: this.cancelReason
      }
      if (this.tripData.jobType === 'cooperate') {
        this.multipleCancel = { ...this.multipleCancel, viewStatus: 'returned' }
      }

      if (this.tripData.isFinishedCalled) {
        this.multipleCancel = { ...this.multipleCancel, isFinishedCancelled: true }
      }

      this.componentLoad = true;
      this.assignTripService
        .assignMultipleTrip(this.multipleCancel)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            // sweetAlert('Success', "Trip Cancelled Successfully", 'success', 'OK')
            this.cancelTripData.emit(this.tripData);
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
    } else {
      this.tripData['changeReason'] = this.cancelReason;
      this.tripData['cancelReasonNote'] = this.cancelReasonNote;
      this.tripData['status'] = "cancelled";
      this.tripData['jobStatus'] = "cancelled";
      this.tripData['cancelReasonNote'] = this.cancelReasonNote;
      if (this.tripData.jobType === 'cooperate') {
        this.tripData['viewStatus'] = "returned";
      }
      if (this.tripData.isFinishedCalled) {
        this.tripData['isFinishedCancelled'] = true
      }
      this.componentLoad = true;


      if (this.user.showOtherLegCancellationAlert) {
        sweetAlert("Cancellation Alert!",
          `We noticed that you cancelled a trip (probably early leg). Would you like to cancel the return trip and any other associated trips for today?`,
          "warning",
          "Yes, cancel all",
          "No, I want others")
          .then((result: any) => {
            if (result.value) {
              this.tripData['isCancelSameDayLegs'] = true;
              this.procedToCancel();
            } else if(result.dismiss) {
              this.tripData['isCancelSameDayLegs'] = false;
              this.procedToCancel();
            }
          });
      } else {
        this.procedToCancel();
      }

    }
  }

  procedToCancel() {
    if (this.isNoShow) {
      this.noShowCancelRequest();
    } else {
      this.simpleCancelRequest();
    }
  }

  simpleCancelRequest() {
    this.assignTripService
      .removeTrip(this.tripData, this.tripData._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // sweetAlert('Success', "Trip Cancelled Successfully", 'success', 'OK')
          this.cancelTripData.emit(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      })
  }

  noShowCancelRequest() {
    this.assignTripService
      .noShowCancelTrip(this.tripData)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.cancelTripData.emit(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      })
  }

  closeCancelModal() {
    this.cancelTripData.emit();
  }

  ngOnDestroy(): void {
  }
}

